<template>
  <header class="w-100" id="my-header">
    <div class="header-search text-center overflow-hidden" id="header-search" style="height: 0;">
      <input type="text" id="skey" class="search-input" placeholder="请输入搜索内容" />
      <input type="button" class="search-sub" value="搜索" @click="subSkey()" />
    </div>
    <div class="header-main position-relative">
      <div class="header-top bg-radial-blue">
        <nav class="navbar navbar-expand-lg navbar-light justify-content-between container text-white">
          <ul class="navbar-nav">
            <li class="nav-item">
              至真至善&nbsp;
              日进日新&nbsp;
              爱岗敬业&nbsp;
              博学尚能&nbsp;
              勤勉善思&nbsp;
              专注笃行
            </li>
          </ul>
          <ul class="navbar-nav">
            <li class="nav-item">
              招生咨询：0311-69108222 / 69108221
            </li>
            <li class="nav-item">
              <p class="search-btn" @click="getSearch()"></p>
            </li>
          </ul>
          <!-- 提示 -->
          <div class="alert alert-warning alert-dismissible fade show m-auto fixed-top s-alert" role="alert">
            请输入搜索内容
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </nav>
      </div>
      <div class="header-nav">
        <nav class="navbar navbar-expand-lg navbar-light container">
          <div class="collapse navbar-collapse justify-content-between" id="navbarSupportedContent">
            <ul class="navbar-nav">
              <li class="nav-item" :class="item.children==null?'':'dropdown'" v-for="item in categoryList.slice(0,4)" :key="item.id">
                <template v-if="item.children==null">
                  <a class="nav-link" :href="item.url?item.url:'javascript:void(0)'">{{item.name}}</a>
                </template>
                <template v-else>
                  <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown1" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{item.name}}</a>
                </template>
                <template v-if="item.children">
                  <div class="dropdown-menu" aria-labelledby="navbarDropdown1">
                    <a class="dropdown-item" v-for="citem in item.children" :key="citem.id" :href="citem.url != '' ? citem.url : categoryUrl + citem.id">{{citem.name}}</a>
                  </div>
                </template>
              </li>
            </ul>
            <ul class="navbar-nav">
              <li class="nav-item" :class="item.children==null?'':'dropdown'" v-for="item in categoryList.slice(4)" :key="item.id">
                <template v-if="item.children==null">
                  <a class="nav-link" :href="item.url?item.url:'javascript:void(0)'">{{item.name}}</a>
                </template>
                <template v-else>
                  <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown1" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{item.name}}</a>
                </template>
                <template v-if="item.children">
                  <div class="dropdown-menu" aria-labelledby="navbarDropdown1">
                    <a class="dropdown-item" v-for="citem in item.children" :key="citem.id" :href="citem.url != '' ? citem.url : categoryUrl + citem.id">{{citem.name}}</a>
                  </div>
                </template>
              </li>
            </ul>
          </div>
        </nav>
      </div>
      <div class="header-logo">
        <a href="/">
          <img id="logo-img" src="/static/img/logo/logo-2.png" />
        </a>
      </div>
      <div class="header-logo-bg" id="header-logo-bg"></div>
    </div>
  </header>
</template>

<script>
  const axios = require('axios');

  export default {
    name: 'my-header',
    data() {
      return {
        site: [{}],
        categoryList: [{}],
        categoryUrl: '/article/category/'
      }
    },
    created() {

    },
    mounted () {
      let that = this;
      // 获取栏目
      axios.get(that.global.apiUrl + '/web/channel/listAll')
        .then(function (response) {
          if (response.data.success && response.data.data.length > 0) {
            that.categoryList = response.data.data;
            that.$nextTick( function () {

            })
          }
        });

      // 获取站点信息
      axios.get(that.global.apiUrl + '/web/site/queryAll')
        .then(function (response) {
          if (response.data.success && response.data.data.length > 0) {
            that.site = response.data.data[0]
            that.site.logoUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + that.site.logo
          }
        });



    },
    watch: {
      // '$route': 'goCatalog'

    },
    methods:{
      getSearch() {
        var h = document.getElementById('header-search').style.height
        if(h == '0px') {
          document.getElementById('header-search').style.height = '70px'
          document.getElementById('header-search').style.animation = 'fade-in 1s ease'
        } else {
          document.getElementById('header-search').style.height = '0'
          document.getElementById('header-search').style.animation = 'fade-out 1s ease'
        }

      },

      subSkey: function() {
          var skey = $("#skey").val().trim()
          if(skey) {
            // console.log('skey:' +skey)
            this.$router.push({
              name: 'search',
              params: {
                skey: skey,
                time: Date.now()
              },
            }).catch(err => {
              console.log('输出报错',err)
            });
          }else {
            $('.alert').show().delay(2000).fadeOut();
            // return false
          }
      },



    }
  }
</script>

<style>
  #my-header {
    /* position: fixed; */
    z-index: 9999999999;
    background-color: #ffffff;
  }
  .header-search {
    width: 100%;
    margin: 0;
    padding: 20px 0;
  }
  .header-top {
    font-size: 14px;
    line-height: 25px;
  }
  .bg-radial-blue {
    background-image: radial-gradient(circle, #104883, #022952);
  }
  .header-nav {
    padding: 10px 0;
  }
  .header-nav .nav-item {
    /* margin-right: ; */
  }
  .header-nav .navbar-nav .nav-link {
    font-size: 16px;
    color: #01366e;
    font-weight: bold;
    margin-left: 0;
    margin-right: 0.8rem;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    margin-left: 0;
  }
  .header-logo {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    left: calc(50% - 80px);
    left: -moz-calc(50% - 80px);
    left: -webkit-calc(50% - 80px);
    z-index: 999999;
  }
  .header-logo img {
    width: 160px;
    height: 160px;
    border: 0;
    border-radius: 50%;
    box-shadow: 0px 8px 10px rgba(0,0,0,0.5);
  }
  .header-logo-bg {
    width: 200px;
    height: 200px;
    background: url(/static/img/bg/logo-bg.png) center bottom no-repeat;
    background-size: contain;
    position: absolute;
    top: -15px;
    left: calc(50% - 100px);
    left: -moz-calc(50% - 100px);
    left: -webkit-calc(50% - 100px);
    z-index: 999998;
  }
  /* 下拉菜单修改为鼠标悬停触发 */
  .header-nav .dropdown:hover>.dropdown-menu {
      display: block;
      /* transition: all 0.3s ease; */
      animation: navRotateY 0.3s ease;
  }
  .header-nav .dropdown>.dropdown-toggle:active {
      pointer-events: none;
  }
  .header-nav .dropdown-menu {
    background-color: #0050a5;
    border: 0;
    margin-top: 0;
    min-width: 6rem;
    border-radius: 0;
  }
  .header-nav .dropdown-menu .dropdown-item {
    color: #fff;
    font-size: 14px;
    line-height: 30px;
  }
  .header-nav .dropdown-menu .dropdown-item:hover {
    background-color: #fff;
    color: #000;
  }
  @keyframes navRotateY {
    0% {
      transform: rotateY(30deg);
    }
     25% {
      transform: rotateY(0deg);
    }
    50% {
      transform: rotateY(-30deg);
    }
    100% {
      transform: rotateY(0);
    }
  }
  .search-btn {
    /* float: left; */
    width: 18px;
    height: 18px;
    background: url(/static/img/icons/sbtn.png) center no-repeat;
    margin: 3px 0 0 15px;
    padding: 0;
    cursor: pointer;
  }
  .search-btn:hover {
    opacity: 0.8;
  }
  .header-search {
    width: 100%;
    /* height: 0px; */
    margin: 0;
    padding: 0;
    /* display: none; */
    /* animation: fade-in 1s ease; */
    /* transition: all 1s ease; */
    overflow: hidden;
  }
  .search-input {
    width: 400px;
    height: 30px;
    border: 1px #ccc solid;
    padding: 3px 5px;
    font-size: 12px;
    margin: 20px 0;
  }
  .search-sub {
    width: 120px;
    height: 31px;
    font-size: 14px;
    border-radius: 0;
    padding: 0;
    color: #fff;
    background-color: #ec3545;
    border: 1px #dc3545 solid;
    text-align: center;
    line-height: 30px;
    margin: 20px 0 0 10px;
  }
  .search-sub:hover {
     background-color: #cc3545;
  }

  @keyframes fade-in {
    0% {height: 0;}
    100% {height: 70px;}
  }
  @-webkit-keyframes fade-in {/*针对webkit内核*/
    0% {height: 0;}
    100% {height: 70px;}
  }
  @keyframes fade-out {
    0% {height: 70px;}
    100% {height: 0;}
  }
  @-webkit-keyframes fade-out {/*针对webkit内核*/
    0% {height: 70px;}
    100% {height: 0;}
  }
  .s-alert {
    width: 200px;
    display: none;
    top: 10px;
    opacity: 0.9;
  }
</style>



// WEBPACK FOOTER //
// src/views/header/header.vue